import styled from 'styled-components';
import Background from '../../assets/AboutContainer/background.png'

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  font-family: 'Arial', sans-serif;
  color: #222;
`;

export const ContainerAbout = styled.div`
  width: 100%;
  background: linear-gradient(0deg, rgb(252, 252, 252) 35%, rgb(226, 223, 223) 100%);
`

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 0;
  flex-wrap: wrap;
  max-width: 900px;
   margin: 0 auto;
`;

export const SectionCircle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 4em 0;

`

export const ImageCircle = styled.div`
  width: 50%;
  padding-left: 5em;
`

export const SquareImage = styled.div`
  opacity: 0.3;
  position: absolute;
  margin-top: -21em;
  z-index: 1;
`

export const SectionValues = styled.div`
background-image: url(${Background});
  display: flex;
  flex-direction: column;
  width: 100%;
  background-size: cover;
  background-position: center;
  padding-bottom: 3em;
`

export const ContainerList = styled.div`
  display: flex;
    justify-content: space-between;
    margin-top: 3em;
`

export const TextBlock = styled.div`
  flex: 1;
  line-height: 1;
`;

export const Title = styled.h1`
  font-size: 2.5em;
  font-weight: bold;
  margin-top: -3em;
`;

export const LogoImage = styled.img`
  width: 250px;
  margin-top: 5em;
`;

export const Doctor = styled.img`
  width: 50%;
`;

export const Ampoules = styled.img`
  width: 40%;
`;

export const Hands = styled.img`
  width: 50%;
`;

export const Subtitle = styled.h2`
  font-size: 3em;
  font-weight: bold;
  padding-left: 3em;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
`;

export const ListItem = styled.li`
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
   font-size: 2.5em;
   padding-left: 5em;
`;

export const ListItemHonesty = styled.li`
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
   font-size: 2.5em;
   padding-left: 8em;
   margin-top: 1.5em;
`

export const ListItemOther = styled.li`
    font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
   font-size: 2.5em;
   padding-left: 8em;

`

export const RedDot = styled.span`
  width: 8px;
  height: 8px;
  background-color: red;
  display: inline-block;
`;

export const BlackDot = styled.span`
  width: 6px;
  height: 6px;
  background-color: black;
  display: inline-block;
  border-radius: 50%;
  margin-right: 5px;
`;

export const Description = styled.li`
  width: 60%;
  color: #555;
  padding-left: 12.5em;
`;

export const DescriptionEthic = styled.li`
  width: 60%;
  color: #555;
  padding-left: 20.3em;
  display: flex;
  align-items: center;

`

export const Commitment = styled.div`
  background: #f0f0f0;
  padding: 20px;
  text-align: center;
  font-weight: bold;

  width: 100%;
  font-size: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5em 0;

  p{
    width: 40%;
  }
`;

export const HandsSection = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;

  img{
    width: 45%;
  }
`

export const CircleAnimation = styled.div`
  position: absolute;
  left: 70%;
  margin-top: -40px;
`